import {Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild} from "@angular/core";

@Directive()
export abstract class FUIAbstractFascia {
    @HostBinding("class.clicked") @Input() public clicked: boolean;
    @Output() public clicked$: EventEmitter<boolean>;
    @HostBinding("class.disabled") @Input() public disabled: boolean;
    private _focussed: boolean;
    @Output() public focussed$: EventEmitter<boolean>;
    @HostBinding("class.hovered") @Input() public hovered: boolean;
    @HostBinding("class.dragging") @Input() public dragging: boolean;
    @ViewChild("input") public input: ElementRef;
    @HostBinding("class.valued") @Input() public valued: boolean;

    constructor() {
        this.clicked$ = new EventEmitter<boolean>();
        this.focussed$ = new EventEmitter<boolean>();
    }

    /**
     *
     * @returns {boolean}
     */
    get focussed(): boolean {
        return this._focussed;
    }

    /**
     *
     * @returns {boolean}
     */
    @HostBinding("class.focussed")
    @Input()
    set focussed(focussed: boolean) {
        if (this._focussed != focussed) {
            this._focussed = focussed;
        }
    }

    /**
     * Watch for click events on the host
     * and action them
     */
    @HostListener("click", ['$event'])
    public click(event: PointerEvent): void {
        if (this.disabled) {
            event.stopPropagation();
        } else {
            this.clicked = true;
            this.clicked$.emit(this.clicked);
        }
    }
}
